import { Component, effect, inject, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ViewEncapsulation } from '@angular/core';
import { NoticeSignal } from '../../signal';

@Component({
    selector: 'app-note',
    templateUrl: './note.component.html',
    styleUrls: ['./note.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NoteComponent {
    readonly noticeSignal = inject(NoticeSignal);
    readonly snackBar = inject(MatSnackBar);

    constructor() {
        effect(() => {
            const notice = this.noticeSignal.notice();
            if (notice) {
                this.snackBar.open(notice.text, undefined, {
                    duration: 5000,
                    panelClass: notice.type
                });
            }
        });
    }

}
